import React, { Component } from 'react'
import { connect } from 'react-redux'
import { publicLoadSimpleIssuesView } from '../actions/issue'
import SimplePublicIssueComponent from '../components/SimplePublicIssue'
import LoadingComponent from '../components/Loading'

class SimplePublicIssue extends Component {

    constructor(props) {
        super(props)

        // Init loading state
        this.state = {
            loading: true
        }
    }

    componentDidMount() {
        const { id, code } = this.props.match.params;
        this.setState({loading: true})
        this.props.loadIssue(id, code)
    }

    componentWillReceiveProps(nextProps) {
        var routeId = nextProps.match.params.id || ''
        var lastRouteId = this.props.match.params.id || ''
        if (routeId !== lastRouteId) {
            this.setState({loading: true})
            this.props.loadIssue(nextProps.match.params.id)
        } else {
            this.setState({loading: false})
        }
    }

    render() {
        if (this.state.loading) return (<LoadingComponent />)
        return (
            <SimplePublicIssueComponent {...this.props} />
        )
    }
}

const mapStateToProps = (state) => {
    const nextProps = Object.assign({}, state.issueView)
    return nextProps
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        loadIssue: (id, code) => {
            dispatch(publicLoadSimpleIssuesView(id, code))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SimplePublicIssue)



// WEBPACK FOOTER //
// ./src/containers/SimplePublicIssue.js